import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Breadcrumb from "../../../core/common/Breadcrumb/breadcrumb";
import Sidebar from "../sidebar/sidebar";
import { all_routes } from "../../router/all_routes";

type ContratoAceite = {
  id: number;
  versaoContrato: string;
  dataAceite: string;
  userAgent: string;
  usuario: {
    id: number;
    nome: string;
    email: string;
  };
};

type Empresa = {
  id: number;
  nome: string;
  status: string;
  contratosAceitos: ContratoAceite[];
};

const CompanyContract = () => {
  const breadcrumbs = [
    { label: "Dashboard", path: "/" },
    { label: "Company Contract" },
  ];
  const routes = all_routes;

  const [empresa, setEmpresa] = useState<Empresa | null>(null);
  const [loading, setLoading] = useState(true);

  const BASE_URL = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchEmpresa = async () => {
      try {
        const res = await axios.get(`${BASE_URL}/empresas/minha`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setEmpresa(res.data);
      } catch (err) {
        console.error("Erro ao buscar empresa", err);
      } finally {
        setLoading(false);
      }
    };

    fetchEmpresa();
  }, [token]);

  return (
    <div>
      <Breadcrumb
        title="My Company"
        breadcrumbs={breadcrumbs}
        backgroundClass="breadcrumb-bg-04"
      />
      <div className="content">
        <div className="container">
          <div className="row">
            {/* Sidebar */}
            <div className="col-xl-3 col-lg-4">
              <Sidebar />
            </div>

            {/* Main Content */}
            <div className="col-xl-9 col-lg-8">
              <div className="card settings mb-0">
                <div className="card-header">
                  <h6>Company Contract</h6>
                </div>
                <div className="card-body pb-3">
                  {/* Settings navigation */}
                  <div className="settings-link d-flex align-items-center flex-wrap mb-4">
                    <Link to={routes.agentSettings} className="ps-3">
                      <i className="isax isax-user-octagon me-2" /> Edit Profile
                    </Link>
                    <Link to={routes.agentAccountSettings}>
                      <i className="isax isax-wallet-money me-2" /> Company Info
                    </Link>
                    <Link
                      to={routes.agentContract}
                      className="active"
                    >
                      <i className="isax isax-document-text me-2" /> Contract
                    </Link>
                  </div>

                  {/* Conteúdo principal */}
                  {loading ? (
                    <p>Loading...</p>
                  ) : empresa ? (
                    <>
                      {empresa.contratosAceitos?.length === 0 ? (
                        <p>No contract accepted yet.</p>
                      ) : (
                        <div className="border rounded p-3 mb-3 bg-light">
                          {empresa.contratosAceitos.map((c) => (
                            <div key={c.id} className="mb-3">
                              <p>
                                <strong>Version:</strong> {c.versaoContrato}
                              </p>
                              <p>
                                <strong>Accepted By:</strong> {c.usuario.nome} (
                                {c.usuario.email})
                              </p>
                              <p>
                                <strong>Date:</strong>{" "}
                                {new Date(c.dataAceite).toLocaleString()}
                              </p>
                              <p>
                                <strong>User Agent:</strong> {c.userAgent}
                              </p>
                              <hr />
                            </div>
                          ))}
                        </div>
                      )}
                    </>
                  ) : (
                    <p>Company not found.</p>
                  )}
                </div>
              </div>
            </div>
            {/* /Main Content */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyContract;
